import { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { currentUser } from "@/App";

const STORAGE_KEY = "terms_update_2026_dismissed";
const EXPIRY_DATE = new Date("2026-04-01T00:00:00");

export default function TermsUpdateBanner() {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "true",
  );

  if (
    !currentUser ||
    dismissed ||
    pathname === "/terms" ||
    new Date() >= EXPIRY_DATE
  ) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setDismissed(true);
  };

  return (
    <Dialog open onClose={() => setDismissed(true)}>
      <DialogTitle>Updated our Terms of Service</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Notebook is updating its Terms of Service, including changes to
          eligibility requirements and revisions to its dispute resolution and
          arbitration provisions. By continuing to use Notebook after April 1,
          2026, you agree to the updated Terms. Please read the updated Terms of
          Service here:
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
        <Button onClick={() => (window.location.href = "/terms")}>
          View Terms
        </Button>
        <Button onClick={handleDismiss}>Dismiss</Button>
      </DialogActions>
    </Dialog>
  );
}
